export enum ExceptionalRecognitionApproverType {
  RegionalHrBp = 'RegionalHrBp',
  GlobalHrBp = 'GlobalHrBp',
  NMinus2 = 'NMinus2',
  HeadOfHierarchy = 'HeadOfHierarchy',
  CAndB = 'CAndB',
  HeadOfHR = 'HeadOfHR',
  HeadOfMA = 'HeadOfMA'
}
